export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-03_00.8b71b9b3.jpg";